import { ref, Ref } from 'vue';
import { Environment } from '@/enums/environment';
import { getEnvironment } from '@/helpers/get-environment';
import { FeatureFlags } from '@/types/feature-flags';
import { FeatureName } from '@/types/feature-name';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class FeatureFlagService {
    private static readonly _featureFlags: Ref<FeatureFlags[Environment] | null> = ref(null);
    private static readonly _environment: Environment = getEnvironment();

    static async init(): Promise<void> {
        try {
            const featureFlagsResponse: Response = await fetch('/feature-flags.json');
            const config: FeatureFlags = await featureFlagsResponse.json();

            this._featureFlags.value = config[this._environment];
        } catch (error: unknown) {
            console.error('Failed to fetch feature flags', error);
        }
    }

    static isFeatureEnabled(feature: FeatureName): boolean {
        if (!this._featureFlags.value) {
            console.error('Feature flags used before initialization');

            return false;
        }

        return this._featureFlags.value[feature];
    }
}

export { FeatureFlagService };
